import * as Sentry from '@sentry/browser';
import {SENTRY_DSN} from '../constants';
import {getCookie} from './cookie';
import DOT from './DOT';
import {getProcessQueueIds} from './logger';

export const initSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: '@sklik/cmp@' + process.env._CMP_VERSION,
    whitelistUrls: [/https:\/\/h\.imedia\.cz\/js\/scmp\.js.*/, /https:\/\/h\.imedia\.cz\/js\/scmp-external\.js.*/]
  });
  const user = getCookie('sid')
    .split('|')[0]
    .split('=')[1];
  Sentry.setUser({
    id: user,
    username: user
  });
};

export const config = (userType, rusId, lazyLoad) => {
  DOT.config(userType, rusId, lazyLoad);
};

export const hit = data => {
  DOT.hit(data);
};

export const start = () => {
  DOT.start();
};

export const end = () => {
  const steps = getProcessQueueIds();
  DOT.end(steps);
};

export const submitClick = (screen, seznamAllowed, contentAllowed, adsAllowed) => {
  DOT.submitClick(screen, seznamAllowed, contentAllowed, adsAllowed);
};

export const exit = screen => {
  DOT.exit(screen);
};

export const show = () => {
  const steps = getProcessQueueIds();
  DOT.show(steps);
};

export const foreignCookie = () => {
  DOT.foreignCookie();
};

export const navPage = navigation => {
  DOT.navPage(navigation);
};

export const profileSaved = () => {
  DOT.profileSaved();
};

export const profileError = () => {
  DOT.profileError();
};

export const getNextShow = data => {
  DOT.getNextShow(data);
};

export const setNextShow = data => {
  DOT.setNextShow(data);
};

export const webview = () => {
  DOT.webview();
};

export const isDotUninitialized = () => DOT.instance === undefined;

export const cookieSaved = () => {
  DOT.cookieSaved();
};
